// removed by extract-text-webpack-plugin
module.exports = {"white":"#FFFFFF","bp":"(min-width: 700px)","outer":"src-pages----ContactPage-module---outer---NF2qv","hidden":"src-pages----ContactPage-module---hidden---3Vmi5","overlay":"src-pages----ContactPage-module---overlay---3cyyW","wrapper":"src-pages----ContactPage-module---wrapper---VCOsN","formColumn":"src-pages----ContactPage-module---formColumn---3omaQ","infoColumn":"src-pages----ContactPage-module---infoColumn---x9M-9","socialIcon":"src-pages----ContactPage-module---socialIcon---2dbh5"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactPage.module.css
// module id = 636
// module chunks = 70144966829960